<script>
import ListingDetailsTabs from "../propertyDetails/listingDetailsTabs.vue";
import FooterSection from "../package/footerSection.vue";
import MoreFromAgent from "../propertyDetails/moreFromAgent.vue";
import MeetAgent from "../propertyDetails/meetAgent.vue";
import BreadcrumbSection from "../package/breadcrumbSection.vue";
import ListingDetails from "../propertyDetails/listingDetails.vue";
import ListingLocation from "../propertyDetails/listingLocation.vue";
import ReserveProperty from "../propertyDetails/reserveProperty.vue";
import PropertyIconSet from "../package/propertyIconSet.vue";
import AdvertisementSection from "./advertisementSection.vue";
import PropertySelection from "./propertySelection.vue";
import DrawerAside from "../package/DrawerAside.vue";
import HeaderSection from "../package/HeaderSection.vue";
import { mapActions } from "vuex";

export default {
  name: "reservationLayout",
  components: {
    HeaderSection,
    PropertySelection,
    AdvertisementSection,
    PropertyIconSet,
    ReserveProperty,
    ListingLocation,
    ListingDetails,
    BreadcrumbSection,
    MeetAgent,
    MoreFromAgent,
    FooterSection,
    ListingDetailsTabs,
    DrawerAside
  },
  beforeUpdate() {
    document.title =
      "UNIFI Property: Select Property (" + this.$route.query.pid + ")";
  },
  data() {
    return {
      adPage: "Property Reservation",
      adSuburbs: "",
      adsData: "",
      unfold: false,
      value1: true,
      theme: "dark",
      switchColor: "#2D2D2D"
    };
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
    this.getAdsbyPageAndSuburb();
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    ...mapActions("home", ["getAds"]),
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
    },
    getAdsbyPageAndSuburb() {
      let body_params = {
        adPage: this.adPage,
        adSuburbs: this.adSuburbs
      };
      this.getAds({
        params: { other: body_params },
        callback: this.callbackAds
      });
    },
    callbackAds(resp) {
      if (resp.data.code == 0) {
        this.adsData = resp.data.data;
      } else {
      }
    }
  }
};
</script>

<template>
  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">
        <property-selection />
        <advertisement-section
          :adLink="adsData.propertyReservation1Click"
          :adUrl="adsData.propertyReservation1"
        />
        <property-icon-set />
      </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}

.main-menu-item-style {
  padding: 30px 40px;
  background-color: #101010;
  border-bottom: 1px solid #585858;
}

.menu-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.sub-menu-item-style {
  padding: 0 40px;
  background: #2d2d2d;
  //background-color: #2D2D2D;
}

.sub-item-font {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.centered-social-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 0 20px 40px;
}

.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 16px 20px 0;
}

.light-dark-text {
  color: #dedede;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Metropolis;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.el-switch /deep/ .el-switch__label--left {
  color: #ffffff;
  //color: #2D2D2D;
}

.el-switch /deep/ .el-switch__label--right {
  color: #ffffff;
}

.el-switch /deep/ .el-switch__core:after {
  background-color: var(--switch-color);
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/reservationLayout.vue